import { PurchasingRepository } from '@Purchasing/Data/Repository/PurchasingRepository'
import { PurchaseProcess } from '@Purchasing/Domain/Model/PurchaseProcess'

export interface UpdatePurchaseProcessAssignee {
    execute(id: string, assignedTo: string): Promise<PurchaseProcess>
    getSource(): string
}

export class UpdatePurchaseProcessAssigneeUseCase
    implements UpdatePurchaseProcessAssignee
{
    constructor(private repository: PurchasingRepository) {}
    async execute(id: string, assignedTo: string): Promise<PurchaseProcess> {
        return this.repository.updateProcessAssignee(id, { assignedTo })
    }
    getSource(): string {
        return this.repository.dataSource.getSource()
    }
}
